<template>
    <PageContent type="center" :compClass="'flex flex-col space-y-6'">
        <div class="flex flex-row items-center justify-between">
            <h1 class="text-xl font-semibold">Network Requests</h1>
        </div>
        <div class="overflow-hidden bg-white shadow sm:rounded-md">
          <ul role="list" class="divide-y divide-gray-200 ">
            <li v-for="request in requests"
              class="block hover:bg-gray-50 cursor-pointer"
              v-on:click="$router.push({'name': 'AdminNetworkRequest', params: {id: request.id}})"
            >
              <div class="flex items-center px-4 py-4 sm:px-6">
                <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                  <div class="truncate">
                    <div class="flex text-sm">
                      <p class="truncate font-medium text-gray-900">{{ request.title }}</p>
                    </div>
                    <div class="mt-2 flex space-x-4">
                      <div class="flex items-center text-sm text-gray-500">
                        <i class="fa-regular fa-building mr-1.5"></i>
                        <p v-if="request.requesting_network !== null">
                          Requested by
                          {{ request.requesting_network.name }}
                        </p>
                        <p v-if="request.requesting_network == null">
                          LSM Content Aggregation
                        </p>
                      </div>
                      <div class="flex items-center text-sm text-gray-500">
                        <i class="fa-regular fa-calendar mr-1.5"></i>
                        <p>
                          Closing
                          {{ request.deadline | displayLocalDateTime('MMMM D, YYYY') }}
                          at
                          {{ request.deadline | displayLocalDateTime('h:mm a') }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="mt-4 flex-shrink-0 sm:mt-0 sm:ml-5">
                    <!-- <div class="flex -space-x-1 overflow-hidden">
                      <img class="inline-block h-6 w-6 rounded-full ring-2 ring-white" src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Dries Vincent">

                      <img class="inline-block h-6 w-6 rounded-full ring-2 ring-white" src="https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Lindsay Walton">

                      <img class="inline-block h-6 w-6 rounded-full ring-2 ring-white" src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Courtney Henry">

                      <img class="inline-block h-6 w-6 rounded-full ring-2 ring-white" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Tom Cook">
                    </div> -->
                  </div>
                </div>
                <div class="ml-5 flex-shrink-0">
                  <!-- Heroicon name: mini/chevron-right -->
                  <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
                  </svg>
                </div>
              </div>
            </li>
          </ul>
        </div>
    </PageContent>
</template>

<script>
import * as Config from "@/config";
import moment from "moment";
import PageContent from "@/components/PageContent";

export default {
  name: "NetworkRequestsLayout",
  data() {
    return {
        requests: [],
    };
  },
  components: {
    PageContent,
  },
  mounted() {
    this.getNetworkRequests();
    // this.getUsersAwaitingPayment();
  },
  methods: {
    async getNetworkRequests() {
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/networks/requests",
      );
      this.requests = res.data
    },
  },
};
</script>
